
(function() {
  var result = { translations: { "it": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} gg", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}g", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, est. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "it": "static-7.1345"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1345",
    "ar-eg": "static-7.1345",
    "bg": "static-7.1345",
    "bn": "static-7.1345",
    "ca-es": "static-7.1345",
    "cs": "static-7.1345",
    "da": "static-7.1345",
    "de": "static-7.1345",
    "el": "static-7.1345",
    "en-gb": "static-7.1345",
    "en": "static-7.1345",
    "es-mx": "static-7.1345",
    "es": "static-7.1345",
    "et": "static-7.1345",
    "fi": "static-7.1345",
    "fr-ca": "static-7.1345",
    "fr": "static-7.1345",
    "he-il": "static-7.1345",
    "hi": "static-7.1345",
    "hr": "static-7.1345",
    "hu": "static-7.1345",
    "id": "static-7.1345",
    "it": "static-7.1345",
    "ja": "static-7.1345",
    "ko": "static-7.1345",
    "lt": "static-7.1345",
    "ms": "static-7.1345",
    "nl": "static-7.1345",
    "no": "static-7.1345",
    "pl": "static-7.1345",
    "pt-br": "static-7.1345",
    "pt-pt": "static-7.1345",
    "ro": "static-7.1345",
    "ru": "static-7.1345",
    "sk": "static-7.1345",
    "sl": "static-7.1345",
    "sv": "static-7.1345",
    "th": "static-7.1345",
    "tl": "static-7.1345",
    "tr": "static-7.1345",
    "uk": "static-7.1345",
    "vi": "static-7.1345",
    "x-pseudo": "static-7.1345",
    "zh-cn": "static-7.1345",
    "zh-hk": "static-7.1345",
    "zh-tw": "static-7.1345"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:it', {version: 'static-7.1345'}); }
})();


